import React from 'react';
import {Link} from 'react-router-dom'
function Shop() {
  return (
    <div >
      <h1>Shop</h1>
      {/* <Link to="/about"> Go to About</Link> */}

    </div>
  );
}

export default Shop;